import React from 'react';
import { Icon } from '../../../../elements/icon';
import useCopy from '../useCopy';

const NUTRIENT_COLORS = ['#C98A3A', '#7A9B3A', '#3A7A9B', '#8A5FA3', '#B5472F'];

const ClashSvg = ({ side, caption }) => {
  const colors = NUTRIENT_COLORS;
  const label = (x, fill) => (
    <text x={x} y="117" textAnchor="middle" fontFamily="'Plus Jakarta Sans', sans-serif" fontSize="15" fontWeight="600" fill={fill} letterSpacing="0.04em">
      {caption}
    </text>
  );

  if (side === 'left') {
    return (
      <svg viewBox="0 0 200 124" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={caption}>
        <ellipse cx="60" cy="58" rx="40" ry="31" fill="#EFE7D3" stroke="#D8C98F" strokeWidth="2" />
        <line x1="60" y1="30" x2="60" y2="86" stroke="#D8C98F" strokeWidth="1.5" opacity=".55" />
        <circle cx="50" cy="52" r="8" fill={colors[0]} />
        <circle cx="64" cy="49" r="8" fill={colors[1]} />
        <circle cx="56" cy="64" r="8" fill={colors[2]} />
        <circle cx="70" cy="63" r="8" fill={colors[3]} />
        <g stroke="#8A3B2A" strokeWidth="2.2" strokeLinecap="round">
          <path d="M58 55 l5 5 M63 55 l-5 5" />
        </g>
        <path d="M108 92 Q140 40 172 92 Z" fill="#EFE7D3" stroke="#D8C98F" strokeWidth="2" />
        <circle cx="132" cy="78" r="5.5" fill={colors[4]} />
        <circle cx="145" cy="72" r="5.5" fill={colors[1]} />
        <circle cx="140" cy="84" r="5.5" fill={colors[2]} />
        <circle cx="152" cy="82" r="5.5" fill={colors[0]} />
        <circle cx="128" cy="86" r="5.5" fill={colors[3]} />
        <g stroke="#8A3B2A" strokeWidth="2" strokeLinecap="round">
          <path d="M140 76 l4 4 M144 76 l-4 4" />
        </g>
        <line x1="14" y1="92" x2="186" y2="92" stroke="#E4DAC1" strokeWidth="2" />
        {label(100, '#8F7A45')}
      </svg>
    );
  }

  const granule = (x, y, index) => (
    <g key={x}>
      <circle cx={x} cy={y} r="13" fill="none" stroke="#9FD3C6" strokeWidth="2" strokeDasharray="3 3" />
      <circle cx={x} cy={y} r="8" fill={colors[index]} />
      <line x1={x} y1={y + 13} x2={x} y2="92" stroke="#9FD3C6" strokeWidth="1.5" />
    </g>
  );

  return (
    <svg viewBox="0 0 200 124" xmlns="http://www.w3.org/2000/svg" role="img" aria-label={caption}>
      <line x1="14" y1="92" x2="186" y2="92" stroke="#9FD3C6" strokeWidth="2" />
      <path d="M182 88 l6 4 l-6 4" fill="none" stroke="#9FD3C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {granule(34, 70, 0)}
      {granule(78, 48, 1)}
      {granule(122, 62, 2)}
      {granule(166, 42, 3)}
      {label(100, '#3F7D73')}
    </svg>
  );
};

export const ClashSlide = () => {
  const c = useCopy();

  return (
    <div className="s-clash">
      <p className="cl-eyebrow">{c.text('PC_Clashes_Eyebrow')}</p>
      <h2 className="cl-title">{c.rich('PC_Clashes_Title')}</h2>
      <div className="cl-card cl-left">
        <p className="cl-label">
          <i className="cl-dot-pressed" />
          {c.text('PC_Clashes_LeftLabel')}
        </p>
        <ClashSvg side="left" caption={c.text('PC_Clashes_AtOnce')} />
        <p className="cl-cap">{c.text('PC_Clashes_LeftCap')}</p>
      </div>
      <div className="cl-card cl-right">
        <p className="cl-label">
          <i className="cl-dot-riise" />
          {c.text('PC_Clashes_RightLabel')}
        </p>
        <ClashSvg side="right" caption={c.text('PC_Clashes_OverTime')} />
        <p className="cl-cap">{c.text('PC_Clashes_RightCap')}</p>
      </div>
      <div className="cl-proof">
        <p>
          <i>
            <Icon raw name="productCarouselCheck" />
          </i>
          {c.text('PC_Clashes_Proof1')}
        </p>
        <p>
          <i>
            <Icon raw name="productCarouselCheck" />
          </i>
          {c.text('PC_Clashes_Proof2')}
        </p>
      </div>
    </div>
  );
};
